import React, { FC } from "react";
import { FormikProps } from "formik";

import { FormRow, Select } from "@/components/common";
import SelectFromCountryFlow, {
  fromCountries,
} from "@/components/common/select/from-country-select/select-from-country-flow";
import SelectToCountryFlow from "@/components/common/select/destination-country-select/select-destination-country-flow";
import SelectRegionFlow from "@/components/common/select/region-select/select-region-flow";
import { useGetRegionsRequest } from "@/api/useGetRegionsRequest";
import { ICalculatorDetails } from "../types";

type Props = {
  formik: FormikProps<ICalculatorDetails>;
};

const SendParcelCountries: FC<Props> = ({
  formik: { values, setFieldValue },
}) => {
  const { data } = useGetRegionsRequest();

  const regionsList = data?.data?.data
    ? data?.data?.data?.map((region) => {
        return {
          id: region.regionId,
          mainText: region.regionName,
        };
      })
    : [];
  return (
    <div className="flex gap-[12px]">
      <FormRow>
        <Select
          label="Select country"
          selectedValue={fromCountries.find(
            (option) => option.id === values.fromCountry,
          )}
          name="fromCountry"
        >
          <SelectFromCountryFlow
            onSelect={(selectedValue: any) => {
              setFieldValue("fromCountry", selectedValue.id);
            }}
          />
        </Select>
      </FormRow>
      <FormRow>
        <Select
          label="Select country"
          // selectedValue={toCountry.find(
          //   (option) => option.id === values.toCountry,
          // )}
          name="toCountry"
        >
          <SelectToCountryFlow
            onSelect={(selectedValue: any) => {
              setFieldValue("toCountry", selectedValue.id);
            }}
          />
        </Select>
      </FormRow>
      <FormRow>
        <Select
          label="Select state/region"
          selectedValue={regionsList.find(
            (option) => option.id === values.toState?.id,
          )}
          name="toState"
        >
          <SelectRegionFlow
            onSelect={(selectedValue: any) => {
              setFieldValue("toState", selectedValue);
            }}
          />
        </Select>
      </FormRow>
    </div>
  );
};

export { SendParcelCountries };
